import RentalCardsSection from "../../components/RentalCardsSubSection";

export default function Favorite({ items }) {
  return (
    <>
      <RentalCardsSection items={items} />
    </>
  );
}
